import {Fragment} from "preact";
import s from "./answerInput.module.css";
import {useAppContext} from "../../../../../contexts";

const AnswerInput = (props) => {
    // Destructured props
    const {
        value,
        label,
        formValues,
        handleChange,
        shouldDisableOptions
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <fieldset className={`flex items-center justify-between gap-x-4 w-max ${!shouldDisableOptions ? "cursor-pointer" : "cursor-default"}`}>
                <input
                    type="radio"
                    name={"answer"}
                    id={`answer-input-${value}`}
                    value={value}
                    className={`${highContrast ? s.dmInput : s.input} ${!shouldDisableOptions ? "cursor-pointer" : "cursor-default"}`}
                    checked={formValues.answer === value}
                    onInput={e => handleChange(e)}
                    disabled={shouldDisableOptions}
                />
                <label
                    htmlFor={`answer-input-${value}`}
                    className={`${highContrast ? s.dmLabel : s.label} ${!shouldDisableOptions ? "cursor-pointer" : "cursor-default"}`}
                >
                    {label}
                </label>
            </fieldset>
        </Fragment>
    )
}

export default AnswerInput
